/**
 * Firebase Messaging (FCM) configuration for AAA FM CRM
 *
 * This is SEPARATE from the old Firestore firebase (src/lib/firebase.js).
 * This uses the NEW Firebase project: area51crm-e2ba5
 * which has the FCM service account you downloaded.
 *
 * Values needed (add to client/.env):
 *   VITE_FCM_API_KEY=...
 *   VITE_FCM_APP_ID=...
 *   VITE_FCM_VAPID_KEY=...
 *
 * Get these from: Firebase Console → area51crm-e2ba5 project
 *   → Project Settings → General → Your apps → Web app
 *   → Project Settings → Cloud Messaging → Web Push certificates (for VAPID)
 */

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

// FCM Firebase project config (area51crm-e2ba5)
// These are safe to be in JS (they are public keys, not secrets).
// The actual security comes from Firebase Security Rules + Service Account on the backend.
const fcmFirebaseConfig = {
    apiKey: import.meta.env.VITE_FCM_API_KEY || "YOUR_API_KEY_HERE",
    authDomain: "aaa-fm-crm.firebaseapp.com",
    projectId: "aaa-fm-crm",
    storageBucket: "aaa-fm-crm.firebasestorage.app",
    messagingSenderId: "571811579506",
    appId: import.meta.env.VITE_FCM_APP_ID || "YOUR_APP_ID_HERE",
};

// Use a named app to avoid conflicts with the existing Firebase app in firebase.js
const FCM_APP_NAME = 'area51crm-fcm';

const fcmApp = getApps().find(a => a.name === FCM_APP_NAME)
    || initializeApp(fcmFirebaseConfig, FCM_APP_NAME);

/**
 * getFirebaseMessaging()
 * Returns the Firebase Messaging instance if the browser supports it.
 * Returns null in unsupported environments (non-HTTPS, service worker blocked, etc.)
 */
export async function getFirebaseMessaging() {
    try {
        const supported = await isSupported();
        if (!supported) {
            console.warn('[FCM] Firebase Messaging not supported in this browser context.');
            return null;
        }
        return getMessaging(fcmApp);
    } catch (err) {
        console.warn('[FCM] Could not initialize Firebase Messaging:', err.message);
        return null;
    }
}

// Your Web Push VAPID key from Firebase Console
// Firebase Console → area51crm-e2ba5 → Project Settings → Cloud Messaging
// → Web configuration → Generate key pair → copy the Key pair value
export const VAPID_KEY = import.meta.env.VITE_FCM_VAPID_KEY || "YOUR_VAPID_KEY_HERE";

export default fcmApp;
